import { GET, PUT } from "./_config";

//user
export const getSettingsData = async () => await GET("/settings");

//admin
export const getSettings = async () =>
  await GET("/settings/get-settings", true);

export const updateSettings = async (body) =>
  await PUT("/settings/update-settings", body, true);
